import {Serializer} from '../interfaces/serializer';
import {DataSetMetric, DataSetMetricsGroup} from '../interfaces/metrics';
import {BehaviorSubject} from 'rxjs';
import {MetricComponentObject, MetricComponentObjects} from './metric-component-object';
import {DataSource} from '../interfaces/data-source';

export type DatasetMetricsGroupComponentObjects = Array<DatasetMetricsGroupComponentObject>;

export class DatasetMetricsGroupComponentObject {
  public payload: Serializer<DataSetMetricsGroup | DataSource>;

  public readonly name$: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  public readonly slug$: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  public readonly length$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  public readonly items$: BehaviorSubject<MetricComponentObjects> = new BehaviorSubject<MetricComponentObjects>([]);

  public readonly primaries$: BehaviorSubject<MetricComponentObjects> = new BehaviorSubject<MetricComponentObjects>([]);
  public readonly secondaries$: BehaviorSubject<MetricComponentObjects> = new BehaviorSubject<MetricComponentObjects>([]);
  public readonly hiddenFields$: BehaviorSubject<MetricComponentObjects> = new BehaviorSubject<MetricComponentObjects>([]);

  public readonly loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);

  constructor(
    payload: Serializer<DataSetMetricsGroup | DataSource>
  ) {
    this.update(payload);
  }

  public update(payload: Serializer<DataSetMetricsGroup | DataSource>): void {
    this.payload = payload;

    this.name$.next(payload.attributes.name);
    this.slug$.next(payload.attributes.slug);
  }

  public init(datasetMetrics: MetricComponentObjects): void {
    let metrics: MetricComponentObjects = [];

    switch (this.payload.type) {
      case 'data_set_metrics_group':
        metrics = datasetMetrics.filter((metric: MetricComponentObject) => metric.payload.relationships.data_set_metrics_group.data?.id === this.payload.id);
        break;
      case 'data_set_usage':
        metrics = datasetMetrics.filter((metric: MetricComponentObject) => metric.payload.relationships.data_source.data?.id === this.payload.relationships.data_source.data.id);
        break;
      case 'data_source':
        metrics = datasetMetrics.filter((metric: MetricComponentObject) => metric.payload.relationships.data_source.data?.id === this.payload.id);
        break;
    }

    this.items$.next(metrics);
    this.length$.next(metrics.length);

    this.primaries$.next(metrics.filter((metric: MetricComponentObject): boolean => (metric.payload.attributes as DataSetMetric).visibility === 'primary' || !('visibility' in metric.payload.attributes)));
    this.secondaries$.next(metrics.filter((metric: MetricComponentObject): boolean => (metric.payload.attributes as DataSetMetric).visibility === 'secondary'));
    this.hiddenFields$.next(metrics.filter((metric: MetricComponentObject): boolean => (metric.payload.attributes as DataSetMetric).visibility === 'hidden'));

    this.loading$.next(false);
  }
}
